import { gql } from '@apollo/client';
import MoneyFields from '../../../graphql/fragments/money/money-fields';
import MasterEntityMinimalFields from '../../../graphql/fragments/master-entity/master-entity-minimal-fields';
import OfferMinimalFields from '../../../graphql/fragments/offer/offer-minimal-fields';

const OPERATIONS_INVOICE_DETAIL = gql`
  query operationsInvoiceDetail($invoiceId: ID!) {
    invoice(invoiceId: $invoiceId) {
      id
      folio
      status
      siiStatus
      creditNoteStatus
      dateOperation
      dateToPay
      collectionDate
      paymentDate
      operationDays
      amountWithIva {
        ...MoneyFields
      }
      receiver {
        ...MasterEntityMinimalFields
      }
      offer {
        ...OfferMinimalFields
        createdAt
      }
      preoffer {
        id
        preofferevaluationrequest {
          id
          pendingdocumentsreviewSet {
            id
          }
        }
      }
      reviewDocumentsManager {
        id
      }
      ratificationmanager {
        id
        assignedPriorityDatetime
      }
      paymentDiscounts {
        id
        retentionAssociated {
          ...MoneyFields
        }
      }
      outstandingCapital {
        ...MoneyFields
      }
      accumulatedDefaultInterest {
        ...MoneyFields
      }
      totalCollectedAmount {
        ...MoneyFields
      }
      surplusDebt {
        ...MoneyFields
      }
      receivedPayments {
        paymentDate
        defaultDays
        amountPaid {
          ...MoneyFields
        }
      }
      historystatusSet {
        id
        status
        createdAt
      }
      customerToPlatformCessionDate
      operation {
        id
        commission {
          ...MoneyFields
        }
        totalAmount {
          ...MoneyFields
        }
        totalInterestAmount {
          ...MoneyFields
        }
        totalAdvanceAmount {
          ...MoneyFields
        }
        financedAmount {
          ...MoneyFields
        }
        totalCosts {
          ...MoneyFields
        }
        advancePercentage
        invoicesCount
        operationSettlement {
          id
          pdfFile
        }
      }
    }
  }
  ${MoneyFields}
  ${MasterEntityMinimalFields}
  ${OfferMinimalFields}
`;

export default OPERATIONS_INVOICE_DETAIL;
